import angular from 'angular';

import { RouterModule } from '../core/router/router.module';
import { configureStates } from '../core/router/router-helper.provider';
import { configureAuthGuard } from './blocks/auth-guard.config';
import { configureMvcRoutes } from './blocks/mvc-routes.config';
import { attachLoadingTransitions, attachStateChangeEvents } from './blocks/state-change.config';
import { configureExcludedAreas } from './blocks/excluded-areas.config';

const routes = [{
    state: "root",
    config: {
        name: "root",
        url: "^",
        component: "apexDashboard",
        params: {
            employeeId: 1
        },
        title: "Home Dashboard",
        data: {
            pageHeader: "Home Dashboard",
            ignoreRole: true
        }
    }
}, {
    state: "home",
    config: {
        name: "home",
        url: "/home",
        redirectTo: "root"
    }
}, {
    state: "home.index",
    config: {
        name: "home.index",
        url: "/index",
        redirectTo: "root"
    }
}, {
    state: "home.acknowledgeLegalNotice",
    config: {
        name: "home.acknowledgeLegalNotice",
        url: "/acknowledgelegalnotice",
        component: "apexAcknowledgeLegalNotice",
        data: { ignoreRole: true }
    }
}, {
    state: "home.support",
    config: {
        url: "/support",
        component: "apexSupport",
        data: {
            pageHeader: "Support",
            ignoreRole: true
        }
    }
}];

export const MainAppRoutingModule = angular
    .module("apex.mainApp.routing", [
        RouterModule
    ])
    .run(configureExcludedAreas)
    .run(configureMvcRoutes)
    .run(configureStates(routes))
    .run(configureAuthGuard)
    .run(attachLoadingTransitions)
    .run(attachStateChangeEvents)
    .name;
